import axios from "axios";
import { storage } from "./storage";

const GENERIC_ERR = "نام کاربری یا رمز عبور نادرست است.";

export async function loginDashboard({ user_name, password, otp, recovery_code, mfa_token }) {
  const body = { user_name, password };
  if (mfa_token) {
    body.mfa_token = mfa_token;
    if (otp) body.otp = otp;
    if (recovery_code) body.recovery_code = recovery_code;
  }
  try {
    const res = await axios.post("/login_user", body);
    return { ok: true, data: res.data };
  } catch (err) {
    const msg =
      (err.response && err.response.data && err.response.data.message) ||
      GENERIC_ERR;
    return { ok: false, message: msg };
  }
}

export async function fetchMe() {
  const token = await storage.load("token");
  if (!token) return null;
  try {
    const res = await axios.get("/auth/me", { headers: { "x-auth": token } });
    return res.data;
  } catch (_) {
    return null;
  }
}

export async function logoutDashboard() {
  const token = await storage.load("token");
  try {
    if (token) {
      await axios.post("/logout_user", {}, { headers: { "x-auth": token } });
    }
  } catch (_) {
    /* ignore */
  }
  await storage.remove("token");
  await storage.remove("role");
}

export function staffAllowedPath(pathname) {
  if (!pathname) return false;
  // Exact home only — do not treat "/dashboard" as a prefix for all routes.
  if (pathname === "/dashboard" || pathname === "/dashboard/") return true;
  if (
    pathname === "/dashboard/access-denied" ||
    pathname.startsWith("/dashboard/access-denied/")
  ) {
    return true;
  }
  const allowPrefix = [
    "/dashboard/getOrders",
    "/dashboard/orderDetails",
    "/dashboard/getShopingList",
    "/dashboard/getQuotes",
  ];
  return allowPrefix.some(
    (p) => pathname === p || pathname.startsWith(p + "/")
  );
}
